import type { SVGProps } from 'react';

const BookmarkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      fill="currentColor"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M26 3C27.6569 3 29 4.34315 29 6V32.5146C29 32.7376 28.7653 32.8827 28.5658 32.7829L18.1342 27.5671C18.0497 27.5249 17.9503 27.5249 17.8658 27.5671L7.43416 32.7829C7.23469 32.8827 7 32.7376 7 32.5146V6C7 4.34315 8.34315 3 10 3H26ZM9.73047 28.583L17.8658 24.5153C17.9503 24.4731 18.0497 24.4731 18.1342 24.5153L26.2695 28.583V6.03047C26.2695 5.86478 26.1352 5.73047 25.9695 5.73047H10.0305C9.86478 5.73047 9.73047 5.86478 9.73047 6.03047V28.583Z" />
    </svg>
  );
};
export default BookmarkIcon;
